import React from 'react';

import Section from 'dpl/quiz/sections/components/Section';

import puppyPng from 'dpl/assets/testimonial_puppy.png';

const PUPPY_IMAGE = { src: puppyPng, width: '176px', height: '164px' };

// The puppy name step, with the puppy illustration above the question
/** @param {any} props */
export default function TestimonialPuppyNameSection(props) {
  return <Section {...props} image={PUPPY_IMAGE} />;
}
